export class customEventsNames{
    constructor() {
        this.accordionInitialised = 'accordionInitialized';
        this.accordionActivateItemEventName = 'activateAccordionItem';
        this.accordionDeactivateItemEventName = 'deactivateAccordionItem';
        this.accordionDeactivateAllItemsEventName = 'deactivateAllAccordionItems';
    }
};
export default new customEventsNames();


// WEBPACK FOOTER //
// ./src/scripts/customEventsNames.js